import styled, { keyframes } from 'styled-components'
import { Grid } from '../style'
import CaptionComponent from './caption'
import Styles from './style-options'

const fadeIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

export const Captions = styled(Grid)`
    grid-row-gap: 10px;
`

export const Caption = styled(CaptionComponent)`
    animation: ${fadeIn} 0.15s ease-out;
    grid-column: span 8;
`

export const StyleOptions = styled(Styles)`
    margin-bottom: 1em;
`
